import { createSlice } from '@reduxjs/toolkit'

const reducerName = 'loader'

const initialState = {
  isActive: false,
  error: null,
  onRetry: () => {},
}

const loaderSlice = createSlice({
  name: reducerName,
  initialState,
  reducers: {
    setGlobalError(state, action) {
      const { text, onRetry } = action.payload

      state.isActive = true
      state.error = text

      if (onRetry && typeof onRetry === 'function') {
        state.onRetry = action.payload?.onRetry
      }
    },

    showLoader(state) {
      state.isActive = true
    },

    disableLoader(state) {
      state.error = null
      state.onRetry = () => {}

      state.isActive = false
    },
  },
})

const { setGlobalError, disableLoader, showLoader } = loaderSlice.actions

export const actions = {
  setGlobalError,
  disableLoader,
  showLoader,
}

export const { reducer } = loaderSlice
